function formatDate(value) {
      let val = (value).replace('T', ' at ')
      return val.toString().slice(0, -8)
}

function hasHistory() {
  return window.history?.length > 1
}

function truncatechars(value, limit) {
  if (value) {
    if (value.length > limit) {
      value = value.substring(0, limit) + "...";
      }
    return value
  }
}

function currencySymbol(currency) {
  let symbol = "$";

  switch (currency) {
    case "EUR":
      symbol = "€";
      break;
    case "GBP":
      symbol = "£";
      break;
    case "JPY":
      symbol = "¥";
      break;
    case "AUD":
      symbol = "A$";
      break;
    case "CAD":
      symbol = "C$";
      break;
    case "CHF":
      symbol = "CHF";
      break;
    case "CNY":
      symbol = "CN¥";
      break;
    case "SEK":
      symbol = "kr";
      break;
    case "NZD":
      symbol = "NZ$";
      break;
    case "KRW":
      symbol = "₩";
      break;
    default:
      // Default symbol is already set to "$"
      break;
  }
  return symbol;
}


export { formatDate, hasHistory, truncatechars, currencySymbol };